// extracted by mini-css-extract-plugin
module.exports = {"shared":"\"../../shared.module.css\"","md":"768px","lg":"992px","xl":"1200px","container":"PageContainer_container__1yhWl"};